import React from 'react';
import ModalAction from '@/components/ModalAction';

const ErrorModal = ({ modalOpen, setModalOpen, error, buttonText = '', onClearModal = null, description = '' }) => {
	const onClearModalCall = () => {
		onClearModal?.();
		setModalOpen(false);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	return (
		<ModalAction id="error-modal" modalOpen={modalOpen} setModalOpen={setModalOpen} onModalClose={handleModalClose}>
			<h2 className="h2 mb-4 pr-16 leading-[0.9] md:pr-0">
				{error}
			</h2>
            {description && <div>{description}</div>}
			<button className="btn-primary w-full mt-8" onClick={onClearModalCall}>
				<span className="pointer-events-none">{buttonText ? buttonText : 'Ok, thanks'}</span>
			</button>
		</ModalAction>
	);
};

export default ErrorModal;
